import Image from '@redbubble/design-system/src/Image';
import Skeleton from '@redbubble/design-system/src/Skeleton';
import Stack from '@redbubble/design-system/src/Stack';
import Text from '@redbubble/design-system/src/Text';
import React from 'react';
import { LicensingMark } from '../types';

export interface LicensedProductsSectionHeaderProps {
  loading: boolean;
  licenseMarks: LicensingMark[];
}

export const LicensedProductsSectionHeaderSkeleton = () => {
  return (
    <Stack spacing="m" data-testid="licensed-products-section-header-skeleton">
      <Skeleton width={128} height={50} animated />
      <Skeleton width={230} height={16} animated />
      <Skeleton width={110} height={25} animated />
    </Stack>
  );
};

export const LicensedProductsSectionHeader = ({
  licenseMarks,
  loading,
}: LicensedProductsSectionHeaderProps) => {
  if (loading) return <LicensedProductsSectionHeaderSkeleton />;

  return (
    <Stack spacing="m">
      {licenseMarks.map((lm) => (
        <React.Fragment key={lm.agreementId}>
          <Image alt={lm.rightsholderName} src={lm.imageSrc} size="medium" />
          <Text muted type="body2">
            {lm.legalLine}
          </Text>
          <Text type="display3" display="block" element="h2">
            {lm.intellectualPropertyName}
          </Text>
        </React.Fragment>
      ))}
    </Stack>
  );
};
